module.exports = __webpack_public_path__ + "static/media/preview.115df124.png";